import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref,onMounted } from 'vue';
import { eAppPaths, eStatusCode } from "@/model/GloblasEnum";
import { useServicesFactoryStore }  from '@/store/services-factory-store';
import { IAppUsuarios } from '@/model/IAppUsuarios';
import { IAppUserDataSincronizacion } from '@/model/IAppUserDataSincronizacion';
import { ISesionApp } from '@/model/ISesionApp';
import {useMainStore} from '@/store/main-store';
import LoginView from '@/views/shared/LoginView.vue';
import PageContentDefault  from '@/views/platforms/PageContentDefault.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  setup(__props) {

let serverResponse = ref({tipo:0,msg:''});
const loginService = useServicesFactoryStore().getLoginService;
const routeService = useServicesFactoryStore().getRouteService;
const syncLocalService = useServicesFactoryStore().getSynLocalDBService;
const registroService = useServicesFactoryStore().getRegistroService;
const mainStore = useMainStore(); 
const loading = ref(false);
const registro = ref(false);
const evalServerResponse = (d:any)=>
{
  serverResponse.value = d;
}
const onRegistro= (route:string) =>
{  
  routeService.go(route);
}
const onLogin = async(values:any) => 
{       
  if (loginService.IsDeleteRegisterFlag(values.userId, values.clave))
  {   
    await registroService.removeFlag();
    await checkFlag();    
  }
  else
  {    
    serverResponse.value.tipo = 0;   
    serverResponse.value.msg = ''; 
    loading.value = true;  
    const user = await loginService.Login(values,evalServerResponse); 
    if(user && user.AppUsuarioId > 0)  
      await SincronizaInformacionAsyn(user); 
    loading.value = false;  
  }
};
const SincronizaInformacionAsyn = async (user: IAppUsuarios) =>
{
  const sync = await syncLocalService.SincronizaInformacionAsynUI(mainStore,loginService,user,true);
  const home = getHome(sync);
  if(home)
    routeService.push(home);
};
const sendToHome = (user: IAppUsuarios, sync: IAppUserDataSincronizacion) =>
{
  if(user && user.AppUsuarioId > 0 && sync && sync.syncValid()) 
  {
    const home = getHome(sync);
    if(home)
      routeService.push(home);    
  } 
};
const getHome = (sync: IAppUserDataSincronizacion)=>
{
  if(sync && sync.syncValid())
  {
    if(sync.IsEmpleado)
    {
      return eAppPaths.homeEmpresa;
    }
    else if (sync.isProveedor())
    {      
      return eAppPaths.homeProvider;
    }
    else if (sync.isCliente())
    {      
      return eAppPaths.homeCustomer;
    }
    else
    {      
      return eAppPaths.homeUser;
    }
  }
  else
  {
    serverResponse.value.tipo = eStatusCode.Error;   
    serverResponse.value.msg = 'Error'; 
  }
  return '';
}
const checkFlag = async()=>
{
  const resp = await registroService.getFlag();
  registro.value = resp? false:true;  
}
onMounted(async ()=>
{        
  const sesion:ISesionApp|null = await loginService.getSession();  
  if(sesion && sesion.User && sesion.SyncData)
  {    
    mainStore.setSesionApp(sesion); 
    sendToHome(sesion.User,sesion.SyncData);
    loginService.VerifyEmpresa(mainStore,sesion.SyncData); 
  }
  await checkFlag();  
}); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContentDefault, null, {
    default: _withCtx(() => [
      _createVNode(LoginView, {
        tipo: 1,
        "show-registro": registro.value,
        onOnLogin: onLogin,
        onOnRegistro: _cache[0] || (_cache[0] = ($event: any) => (onRegistro($event))),
        serverResponse: _unref(serverResponse),
        loading: loading.value
      }, null, 8, ["show-registro", "serverResponse", "loading"])
    ]),
    _: 1
  }))
}
}

})